<template>
  <div class="activity">
    <img src="../../assets/img/common/icon2.png" class="img1" />
    <img src="../../assets/img/common/icon1.png" class="img2" />
    <div class="words">
      <p v-for="(item, index) in activityObj.words" :key="index">{{item}}</p>
    </div>
    <!-- <img src="../../assets/img/m/activity/activity_title.png" class="title-img"> 
    
    <div class="code-box">
        <img :src="activityObj.codeImg" class="code">
        <p class="dec"> <a    class="goto-btn"><img src="../../assets/img/m/activity/btn.png"></a></p>
       
        <img src="../../assets/img/m/activity/icon1.png" class="img2"> 
    </div>-->

    <!-- <img src="../../assets/img/m/activity/prize_title.png" class="title-img"> -->
    <div class="prize-dec">
      <!-- <div class="prize-img">
          <div class="item" v-for="(prize, index) in activityObj.prizes" :key="index">
            <img :src="prize.img" class="img-icon" alt />
            <p class="level"><span>{{prize.level}}</span><span>{{prize.num}}</span></p>
            <p class="name">{{prize.name}}</p>
          </div> 
        </div> 
      <p class="tip">(礼品以实物为准)</p>-->
      <div class="activity-box">
        <div class="text" v-for="(rule, index) in activityObj.rules" :key="index">
          <p class="title">{{rule.title}}</p>
          <div v-html="rule.value"></div>
        </div>
        <p class="remark" v-for="(remark,index) in activityObj.remark" :key="index">{{ remark }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { textObj } from "../../assets/js/textobj.js";
export default {
  name: "activity",
  data() {
    return {};
  },
  created() {},
  computed: {
    activityObj() {
      return textObj.activity;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" >
$wordsColor: #363636;
.activity {
  width: 100%;
  height: auto;
  margin: 0.3rem auto 0;
  position: relative;
  .img1 {
    width: 6.32rem;
    height: 2.5rem;
    position: absolute;
    top: 14rem;
    left: 0;
  }
  .img2 {
    width: 5.05rem;
    height: 2.92rem;
    position: absolute;
    bottom: 5rem;
    right: 0;
  }
  .poem {
    width: 100%;
    position: relative;
    padding-top: 0.5rem;
    .icon1 {
      width: 2.43rem;
      height: 1.27rem;
      display: inline-block;
      position: absolute;
      top: -0.4rem;
      left: 0;
    }
    > p {
      width: 100%;
      text-align: center;
      color: $wordsColor;
      font-size: 0.44rem;
      line-height: 2em;
      letter-spacing: 0.04rem;
    }
  }
  .words {
    width: 13.8rem;
    font-size: 0.32rem;
    color: $wordsColor;
    font-weight: normal;
    margin-top: 0.5rem;
    line-height: 1.6em;
    letter-spacing: 0.02rem;
    margin: auto;
    > p {
      width: 100%;
      text-indent: 2em;
      text-align: left;
      display: block;
      margin: auto;
    }
  }

  .code-box {
    width: 100%;
    text-align: center;
    position: relative;
    .code {
      width: 5.17rem;
      display: block;
      margin: 0.3rem auto 0.3rem;
      z-index: 1;
      position: relative;
    }

    .img2 {
      width: 1.91rem;
      height: auto;
      position: absolute;
      top: 2.4rem;
      left: 5.3rem;
      z-index: 0;
    }
    .dec {
      margin-top: 0.1rem;
    }
  }
  .goto-btn {
    width: 7.11rem;
    display: inline-block;
    position: relative;
    z-index: 1;
    > img {
      width: 100%;
    }
  }
  .title-img {
    width: 4.13rem;
    height: auto;
    display: inline-block;
    margin: auto;
  }
  .prize-dec {
    width: 80%;
    min-width: 10rem;
    height: auto;
    margin: auto;
    position: relative;
    padding: 0 0.3rem 0;
    font-size: 0.3rem;
    color: $wordsColor;

    .prize-img {
      width: 100%;
      display: flex;
      justify-content: space-between;
      text-align: center;
      font-size: 0.18rem;
      color: $wordsColor;
      font-weight: bold;
      margin-top: 0.5rem;
      .img-icon {
        width: 100%;
        height: auto;
        display: inline-block;
        border-radius: 50%;
      }
      .item {
        width: 28%;
        position: relative;
        .level {
          margin-top: 0.2rem;
          font-size: 0.4rem;
        }
        .name {
          font-size: 0.32rem;
          margin-top: 0.1rem;
        }

        > img {
          width: 100%;
          max-width: 3.51rem;
          height: auto;
          display: block;
          margin: auto;
        }
      }
    }
    .remark {
      margin-top: 0.2rem;
      color: $wordsColor;
      text-align: right;
    }
    .activity-box {
      width: 100%;
      text-align: left;
      font-size: 0.32rem;
      line-height: 1.6em;
      font-weight: normal;
      margin: 0.6rem auto 0;
      position: relative;

      .item {
        width: 100%;
        margin: 0.3rem auto 0;
        display: flex;
        // font-style: italic;
        font-size: 0.48rem;
        font-weight: bold;
        .text {
          width: 100%;
          font-size: 0.32rem;
          .box + .box {
            margin-top: 0.2rem;
          }
        }
        .text.icon3 {
          width: 100%;
        }

        .img {
          width: 5.4rem;
          display: inline-block;
          position: absolute;
          top: 0;
          right: -0.8rem;
          box-sizing: border-box;
          > img {
            width: 100%;
          }
        }
      }
      .item.part4 {
        margin-top: 0;
        .text {
          width: 100%;
        }
      }
      .title {
        font-weight: bold;
        font-size: 0.48rem;
        margin-bottom: 0.2rem;
        margin-top: 0.2rem;
        color: #363636;
      }
      .time {
        margin-bottom: 0.3rem;
      }
      .rule {
        margin-top: 0.5rem;
      }
    }
  }
  .text-box {
    width: 100%;
    height: auto;
    position: relative;
    display: block;
    margin: auto;
    color: $wordsColor;
    font-size: 0.4rem;
    > p {
      font-size: 0.4rem;
      font-weight: bold;
      color: #f3c88a;
      line-height: 1.4em;
      text-indent: 2em;
      text-align: left;
    }
    > p + p {
      margin-top: 0.2rem;
    }
  }
  .title-img {
    width: 4.13rem;
    height: auto;
    position: relative;
    display: block;
    margin: 0.56rem auto 0.17rem;
    padding-top: 0.8rem;
  }
  .title2 {
    font-weight: normal;
    text-indent: 2em;
  }
  .title2-value {
    letter-spacing: 0;
    line-height: 1.3em;
  }
  .tip {
    width: 100%;
    margin-top: 0.3rem;
    text-align: center;
  }
}
.line-name {
  width: 100%;
  display: flex;
  .lable {
    width: 6em;
  }
  .dec {
    width: calc(100% - 6em);
    padding-left: 0.1rem;
    > span {
      display: block;
    }
  }
}
</style>
